import { render, staticRenderFns } from "./RegisterSingleBuildingProject.vue?vue&type=template&id=c52edf96"
import script from "./RegisterSingleBuildingProject.vue?vue&type=script&lang=js"
export * from "./RegisterSingleBuildingProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports